<template>
  <div class="button-menu-wrapper" >
    <span class="new-item stop-event" v-if="isNew">new</span>
    <div class="button-menu stop-event">
        <span class="button-menu-icon base-sprite flex center button-format-item" :class="iconClass" v-if="iconClass">
          <sw-icon v-if="network!==''" :icon='icon' font='fa' class="fa-brands"/>
        </span>
        <span class='button-menu-label'  v-if="label">{{label}}</span>
    </div>
  </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////

//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'ButtonFormat',
  components: {
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  data () {
    return {}
  },
  props: {
    iconClass:{
      type:String,
      default:''
    },
    label:{
      type:String,
      default:''
    },
    icon:{
      type:String,
      default:''
    },
    network:{
      type:String,
      default:''
    },
    isNew:{
      type:Boolean,
      default:false
    }
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/buttons/ButtonFormat.vue